function JobCategoriesHealthCareIcon({ color = "#191515" }) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 54.997C30.2737 54.997 28.875 53.5982 28.875 51.872V12.127C28.875 10.4007 30.2737 9.00195 32 9.00195C33.7263 9.00195 35.125 10.4007 35.125 12.127V51.872C35.125 53.5982 33.7263 54.997 32 54.997Z"
        fill={color}
      />
      <path
        d="M51.8724 35.125H12.1274C10.4012 35.125 9.00244 33.7263 9.00244 32C9.00244 30.2737 10.4012 28.875 12.1274 28.875H51.8724C53.5987 28.875 54.9974 30.2737 54.9974 32C54.9974 33.7263 53.5987 35.125 51.8724 35.125Z"
        fill={color}
      />
    </svg>
  );
}

export default JobCategoriesHealthCareIcon;
